export default "__VITE_ASSET__BdayMn27__"